import React from 'react'
import customRequest from '../../../helpers/customRequest'
import initializeLocations, { getStates } from '../../../helpers/forms/location-form'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'
import message from '../../../components/message/message'
import ClipLoader from 'react-spinners/ClipLoader'

class Information extends React.Component
{
    state = {
        countriesOptions: [],
        loading: true,
        submitting: false
    }
    
    componentDidMount() {
        customRequest.get("/api/countries")
		.then(({data: countriesData}) => {
			this.setState({
				countriesOptions: countriesData.countries
            }, () => {
                let data = this.props.info
                if (!document.getElementById("information-form") || !data)
                {
                    return
                }
                document.getElementById("name").value = data.name
                document.getElementById("email-address").value = data.email
                document.getElementById("address").value = data.streetAddress
                document.getElementById("city").value = data.city
                document.getElementById("country").value = data.country
                document.getElementById("state-autofill").value = data.state
                getStates(document.getElementById("country"))
                
                document.getElementById("postal-code").value = data.postalCode
                document.getElementById("phone").value = data.phoneNumber
                document.getElementById("fax").value = data.faxNumber
                this.setState({loading: false})
            })
        })

        initializeLocations();
		initializeFormValidation(this.onSubmit);
    }

    onSubmit = () => {
        this.setState({loading: true, submitting: true}, () => {
            customRequest.get('/api/account/info')
            .then((infoResponse) =>
            {
                if (!document.getElementById("information-form"))
                {
                    return
                }

                message.clear()
                var {name, email, streetAddress, city, country, state, postalCode, phoneNumber, faxNumber} = infoResponse.data
                var newName = document.getElementById("name").value
                var newEmail = document.getElementById("email-address").value
                var newStreet = document.getElementById("address").value
                var newCity = document.getElementById("city").value
                var newCountry = document.getElementById("country").value
                var newState = document.getElementById("state").value
                var newPostalCode = document.getElementById("postal-code").value
                var newPhoneNumber = document.getElementById("phone").value
                var newFaxNumber = document.getElementById("fax").value

                if (name == newName && newEmail == email && newStreet == streetAddress && newCity == city && newCountry == country && newState == state && newPostalCode == postalCode && newPhoneNumber == phoneNumber && newFaxNumber == faxNumber)
                {
                    this.setState({loading: false, submitting: false})
                    message.error("You did not change any of your account information.")
                    return
                }

                let emailChanged = newEmail != this.props.info.email

                customRequest.post('/api/account/edit', {
                    name: newName,
                    email: newEmail,
                    streetAddress: newStreet,
                    city: newCity,
                    country: newCountry,
                    state: newState,
                    postalCode: newPostalCode,
                    phoneNumber: newPhoneNumber,
                    faxNumber: newFaxNumber,
                    currentPassword: document.getElementById("current-password").value
                })
                .then(({data}) => {
                    this.setState({loading: false, submitting: false})
                    if (data.valid) {
                        message.success("Your account information has been successfully updated.")
                        document.getElementById("current-password").value = ""
                        this.props.updateInfo()

                        if (emailChanged) {
                            message.info("Please check your updated email address for a verification link. Until you verify your new address, all messages about your account will come to your old email address.")
                        }
                    }
                    else {
                        message.error(data.message)
                    }
                })
            })
        })
    }

    render() {
        return <form class = "form-horizontal form-validate" id="information-form" noValidate method = "post">
        
        <div class = "form-group row">
            <label for = "name" class = "d-none d-sm-inline col-sm-3 control-label text-right">Name</label>
            
            <div class = "col-sm-6">
                <input type = "text" disabled={this.state.loading} class = "form-control" id = "name" name = "name" placeholder = "Name" required data-description = "enter a name" autofocus />
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "email-address" class = "d-none d-sm-inline col-sm-3 control-label text-right">Email&nbsp;Address</label>
            
            <div class = "col-sm-6">
                <input type = "email" disabled={this.state.loading} class = "form-control unique" id = "email-address" name = "email-address" placeholder = "Email Address" autocomplete = "off" required data-description = "enter an email address" />
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "address" class = "d-none d-sm-inline col-sm-3 control-label text-right">Street Address</label>
            
            <div class = "col-sm-6">
                <div class = "input-group">
                    <input type = "text" disabled={this.state.loading} class = "form-control string" name = "address" id = "address" placeholder = "Street Address" maxlength = "175" data-type = "address" data-description = "enter a street address" />
                    <span class = "input-group-text">optional</span>
                </div>
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "city" class = "d-none d-sm-inline col-sm-3 control-label text-right">City</label>
            
            <div class = "col-sm-6">
                <input type = "text" disabled={this.state.loading} class = "form-control string" name = "city" id = "city" placeholder = "City" maxlength = "175" data-type = "city" data-description = "enter a city" required />
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "country" class = "d-none d-sm-inline col-sm-3 control-label text-right">Country</label>
            
            <div class = "col-sm-6">
                <select class = "form-control" disabled={this.state.loading} name = "country" id = "country" required data-description = "select a country">
                    <option value="" disabled selected>Country:</option>
                    {this.state.countriesOptions.map((item) => {
                        return (<option value={item}>{item}</option>)
                    })}
                </select>
            </div>
        </div>
        
        <div class = "state-autofill-target">
            <input type = "text" name = "state-autofill" id = "state-autofill" />
        </div>
        
        <div class = "form-group row">
            <label for = "state" class = "d-none d-sm-inline col-sm-3 control-label text-right">State or Province</label>
            
            <div class = "col-sm-6">
                <select class = "form-control" disabled={this.state.loading} name = "state" id = "state" required data-description = "select a state or province">
                </select>
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "postal-code" class = "d-none d-sm-inline col-sm-3 control-label text-right">Postal Code</label>
            
            <div class = "col-sm-6">
                <input type = "text" disabled={this.state.loading} class = "form-control string" name = "postal-code" id = "postal-code" placeholder = "Postal Code" maxlength = "175" data-type = "postal code" data-description = "enter a postal code" required/>
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "phone" class = "d-none d-sm-inline col-sm-3 control-label text-right">Phone Number</label>
            
            <div class = "col-sm-6">
                <input type = "text" disabled={this.state.loading} class = "form-control string" name = "phone" id = "phone" placeholder = "Phone Number" maxlength = "175" data-type = "phone number" data-description = "enter a phone number" required />
            </div>
        </div>
        
        <div class = "form-group row">
            <label for = "fax" class = "d-none d-sm-inline col-sm-3 control-label text-right">Fax Number</label>
            
            <div class = "col-sm-6">
                <div class = "input-group">
                    <input type = "text" disabled={this.state.loading} class = "form-control string" name = "fax" id = "fax" placeholder = "Fax Number" maxlength = "175" data-type = "fax number" data-description = "enter a fax number" />
            
                    <span class = "input-group-text">optional</span>
                </div>
            </div>
        </div>
        
        
        <div class = "form-group row">
            <label for = "current-password" class = "d-none d-sm-inline col-sm-3 control-label text-right">Current Password</label>
            
            <div class = "col-sm-6">
                <input type = "password" disabled={this.state.loading} class = "form-control string" id = "current-password" name = "current-password" placeholder = "Current Password" required data-type = "current password" minlength = "5" data-description = "enter your current password" />
            </div>
        </div>
        
        <button type = "submit" disabled={this.state.loading} class = "btn btn-secondary btn-lg">{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Change Information"}</button>
    </form>
    }
}

export default Information
